const BootScreen = () => {
    return <div style={{position:"absolute", display:"flex", width: "100vw", height: "100vh", backgroundColor:"black", zIndex:"100",
        alignItems:"center",justifyContent:"center"
    }}>
        <img style={{maxWidth:"30vw"}} src="logo192.png"></img>
    </div>
}

export default BootScreen